<template>
  <div id="seed" style="overflow:hidden;">
    <div class="seed-data">
      <div class="seed-data-title">
        <div class="send-title-left">
          <span class="send-title-left-container" style="">苗情设备数据</span>
        </div>

        <div class="send-title-middle" >
          <div class="send-title-middle-container">
            设备名
            <el-select @change="seedChange($event)" v-model="seedSelect" filterable >
              <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in seedOption" >
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="send-title-right">
          <div class="send-title-right-container">
            摄像头名
            <el-select @change="videoChange($event)" v-model="seedVideoSelect" filterable :disabled="seedFlg">
              <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in seedVideoOption" >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="seed-data-content">
<!--        <div class="seed-content-top">-->
<!--          <el-radio-group @change="modelSelect" v-model="radio" style="display: table-cell; vertical-align: middle">-->
<!--            <el-radio label="theme">标准版</el-radio>-->
<!--            <el-radio label="simple">极简版</el-radio>-->
<!--            <el-radio label="security">安防版</el-radio>-->
<!--            <el-radio label="voice">语音版</el-radio>-->
<!--          </el-radio-group>-->
<!--        </div>-->

<!--        <div id="video-container" class="seed-content-bottom" ref="Temp"> 摄像头画面大小动态变化 -->
        <div id="video-container" class="seed-content-bottom">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import EZUIKit from 'ezuikit-js'
  import axios from 'axios'
  import {getAttributesShared} from "../../until/api/MeteSoil";

  export default {
    name: 'SeedData',
    components: {},
    data() {
      return {
        seedOption: [],
        seedSelect: '',
        seedVideoOption: [],
        seedVideoSelect:'',
        seedVideoAddress: [],
        seedAppKey: '',
        seedSecret: '',
        seedDeviceSerial: '',
        seedAccessToken: '',
        seedVideoUrl: '',
        seedPlayer: null,
        windowWidth: document.documentElement.clientWidth, //摄像头画面大小固定
        windowHeight: document.documentElement.clientHeight,//摄像头画面大固定
        // tempWidth: 0, // 摄像头画面大小动态变化
        // tempHeight: 0,// 摄像头画面大小动态变化
        seedVideoTime: '',
        seedFlg: true,
        radio: 'theme',
        channelNo: 1,
      }
    },

    beforeDestroy() {
      clearInterval(this.seedVideoTime);
      this.seedVideoTime = null;
    },

    mounted() {
      //获取用户等级
      //let authority = this.$route.params.authority === undefined ? localStorage.getItem('authority') : this.$route.params.authority;
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      //获取用户id
      //let customerId = this.$route.params.customerId === undefined ? localStorage.getItem('customerId') : this.$route.params.customerId;
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')) : this.$route.params.customerId;
      let that = this;
      this.$MeteSoilCommon.getDeviceList(authority, customerId, function (deviceList) { //获取设备
        that.seedDeviceBoards(deviceList);//获取设备列表
      });

      // 摄像头画面大小动态变化
      // this.tempWidth = this.$refs.Temp.offsetWidth - 30;
      // this.tempHeight = this.$refs.Temp.offsetHeight - 20;
      // window.onresize = () => {
      //   return (() => {
      //     that.tempWidth = this.$refs.Temp.offsetWidth -30;
      //     that.tempHeight = this.$refs.Temp.offsetHeight - 20;
      //     this.seedVideoShow();
      //   })()
      // }
    },

    methods: {
      /**
       * 获取设备列表
       * @param response
       */
      seedDeviceBoards(response){
        if(response.data.length === 0) return;
        for(let i = 0; i < response.data.length; i++) {
          let seedJson = {};
          seedJson.id = response.data[i].id.id;
          seedJson.name = response.data[i].name;
          seedJson.type = response.data[i].id.entityType;
          this.seedOption.push(seedJson);
        }
        if(this.seedOption.length > 0) {
          this.seedSelect = this.seedOption[0].id;
          this.getSeedVideo(); //根据设备获取摄像头
        }
      },

      /**
       * 切换设备
       * @param event
       */
      seedChange(event) {
        this.seedSelect = event;
        this.getSeedVideo();//根据设备获取摄像头
      },

      /**
       * 根据设备获取摄像头
       */
      getSeedVideo() {
        this.seedVideoOption = [];
        this.seedVideoSelect = '';
        this.seedVideoAddress = [];
        this.seedAppKey = '';
        this.seedSecret = '';
        this.seedDeviceSerial = '';
        let that = this;
        this.$MeteSoilCommon.getCredentialsInfo(this.seedSelect, function (deviceInfo) {//获取设备信息
          let num = 0;
          getAttributesShared(deviceInfo.entityType, deviceInfo.id).then(response => {//获取服务端数据
            for(let i = 0; i < response.data.length; i++) {
              if(response.data[i].key.toString().indexOf('vedio') !== -1) {
                let json = JSON.parse(response.data[i].value);
                let videoJson = {};
                videoJson.id = num;
                videoJson.name = json.deviceSerial;
                that.seedVideoOption.push(videoJson);
                that.seedVideoAddress.push(json);
                num++;
              }
            }
            that.seedVideoOption.length == '' ? that.seedFlg = true : that.seedFlg = false; //设置摄像头是否可以被点击
            that.seedVideoOption.length == '' ? that.seedVideoSelect = '' : that.seedVideoSelect = that.seedVideoOption[0].id;//初期化选中的摄像头
            that.seedVideoAddress.length == '' ? that.seedAppKey = '' : that.seedAppKey = that.seedVideoAddress[0].appKey;//初期换摄像头的appkey
            that.seedVideoAddress.length == '' ? that.seedSecret = '' : that.seedSecret = that.seedVideoAddress[0].secret;//初期化摄像头的secret
            //that.seedVideoAddress.length == '' ? that.seedDeviceSerial = '' : that.seedDeviceSerial = that.seedVideoAddress[0].deviceSerial;//初期化摄像头的deviceSerial
            //初期化选中摄像头的deviceSerial
            if(that.seedVideoAddress.length == '') {
              that.channelNo = 0;
              that.seedDeviceSerial = '';
            } else {
              that.channelNo = 1;
              if(that.seedVideoAddress[0].deviceSerial.indexOf('-') !== -1) {
                that.seedDeviceSerial = that.seedVideoAddress[0].deviceSerial.split("-")[0];
                that.channelNo = that.seedVideoAddress[0].deviceSerial.split("-")[1];
              } else {
                that.seedDeviceSerial = that.seedVideoAddress[0].deviceSerial;
              }
            }
            that.seedVideoShow();//获取播放地址并播放视频
          }).catch(error => {
            console.log("error", error);
          })
        })
      },

      /**
       * 切换摄像头
       * @param event
       */
      videoChange(event) {
        this.seedVideoSelect = this.seedVideoOption[event].id; //获取选中的摄像头
        this.seedAppKey = this.seedVideoAddress[event].appKey; //获取选中摄像头的appkey
        this.seedSecret = this.seedVideoAddress[event].secret; //获取选中摄像头的secret
        //this.seedDeviceSerial = this.seedVideoAddress[event].deviceSerial; //获取选中摄像头的deviceSerial
        let deviceNum = this.seedVideoAddress[event].deviceSerial;//选中摄像头的deviceSerial
        this.channelNo = 1;
        if(deviceNum.indexOf('-') !== -1) {
          this.seedDeviceSerial = deviceNum.split("-")[0];
          this.channelNo = deviceNum.split("-")[1];
        } else {
          this.seedDeviceSerial = deviceNum;
        }
        this.seedVideoShow();//获取播放地址并播放视频
      },

      /**
       * 获取播放地址并播放视频
       */
      seedVideoShow() {
        document.getElementById('video-container').innerHTML = ""; //摄像头画面清空
        this.seedPlayer = null;//播放视频清空
        if(this.seedAppKey !== '' && this.seedSecret !== '' && this.seedDeviceSerial !== '') {
          Promise.all([
            this.getSeedAccessToken()//获取accesstoken
          ]).then(res => {
            Promise.all([
              this.getSeedVideoUrl()//获取播放地址
            ]).then(res => {
              if(this.seedVideoTime != null) {
                clearInterval(this.seedVideoTime);
                this.seedVideoTime = null;
              }
              this.setSeedPlayVideo();//摄像头播放
              this.seedVideoTime = window.setInterval(() => {//每隔十分钟重新播放一次摄像头
                setTimeout(() =>{
                  this.setSeedPlayVideo();//摄像头播放
                },0)
              }, 1000 * 60 * 10)
            })
          })
        } else {
          return;
        }
      },

      /**
       * 获取accessToken
       * @returns {Promise<AxiosResponse<any>>}
       */
      getSeedAccessToken() {
        let url = '/api/lapp/token/get?appKey=' + this.seedAppKey + '&appSecret=' + this.seedSecret;
        return axios({
          method: 'post',
          baseURL:process.env.API,
          url,
          headers: {
            'Content-Type':'application/x-www-form-urlencoded'
          },
          timeout: 10000
        }).then(response => {
          this.seedAccessToken = response.data.data.accessToken;
        })
      },

      /**
       * 获取播放url
       * @returns {Promise<T>}
       */
      getSeedVideoUrl() {
        let url = '/api/lapp/v2/live/address/get?accessToken=' + this.seedAccessToken + '&deviceSerial=' + this.seedDeviceSerial + '&channelNo=' + this.channelNo;
        return axios({
          method: 'post',
          baseURL: process.env.API,
          url,
          headers: {
            'Content-Type':'application/x-www-form-urlencoded'
          },
          timeout: 10000
        }).then(response => {
          if(response.data.msg == "操作成功") {
            this.seedVideoUrl = response.data.data.url;
          } else {
            this.seedVideoUrl = 'ezopen://open.ys7.com/' + this.seedDeviceSerial + '/' + this.channelNo + '.hd.live';
          }
        }).catch(error => {
          this.seedVideoUrl = 'ezopen://open.ys7.com/' + this.deviceSerial + '/1.hd.live';
          console.log("error", error);
        })
      },

      /**
       * 播放视频
       */
      setSeedPlayVideo() {
        if(this.channelNo == 1) {
          this.seedPlayer = new EZUIKit.EZUIKitPlayer({
            autoplay: true,
            id: "video-container",
            accessToken: this.seedAccessToken,
            url: this.seedVideoUrl,
            template: 'theme',
            width: this.windowWidth * 0.81, //摄像头画面大小固定
            height: this.windowHeight * 0.8 //摄像头画面大小固定
            // width: this.tempWidth,  //摄像头画面大小动态变化
            // height: this.tempHeight //摄像头画面大小动态变化
          })
        } else {
          this.seedPlayer = new EZUIKit.EZUIKitPlayer({
            autoplay: true,
            id: "video-container",
            accessToken: this.seedAccessToken,
            url: this.seedVideoUrl,
            template: 'simple',
            width: this.windowWidth * 0.81, //摄像头画面大小固定
            height: this.windowHeight * 0.8 //摄像头画面大小固定
            // width: this.tempWidth,  //摄像头画面大小动态变化
            // height: this.tempHeight //摄像头画面大小动态变化
          })
        }

      },

      // modelSelect(e) {
      //   this.radio = e;
      //   //console.log("1111111111",e)
      // }
    }
  }
</script>

<style lang="less">
  @import "../less/SeedData";
</style>



// WEBPACK FOOTER //
// src/components/view/SeedData.vue